import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-lst',
  templateUrl: './lst.component.html',
  styleUrls: ['./lst.component.scss']
})
export class LstComponent implements OnInit {

  @ViewChild('commonModal')
  public commonModal: any;

  @ViewChild('successModal') successModal: any;
  
  lstForm: FormGroup;
  customerIndiaForm: FormGroup;
  loginData: any;
  empNameMultiSelectItems: any = [];
  empList: any[] = [];
  multiDropdownSettings2: any;
  isAdmin: any;
  isLstAccess: any;
  LoaderComponent: any = '';
  lastValue: any;
  displayValues: any = [];
  allDisplayValues: any = [];
  profileOwnerArray: any = [];
  profileTypeArray: any = [];
  responseMessage: any;
  matchedHeaders: any = []
  headers: any = [];
  formValue: any;
  requestData: any;
  gridType2: any;
  allRecord: any = [];
  totalFields: any = [];
  allheaders: any = [];
  maxDate = new Date;
  prevDate = new Date;
  loadedAllData: boolean = false;
  scrollDown: boolean;
  ticketData: any;
  isTicketCreteClicked: boolean;
  isDisplayInterested: boolean = true;
  isOtherSideSecession: boolean = false;
  selectedTabType: string = 'MSI';
  tabValue: any;
  search1: string = 'home';
  search2: string;
  checkedHome: boolean = false;
  expanded: boolean = true;
  arrivalExpand: boolean = true;
  type: any = 'communication';
  gridType: any = 'com2'
  multiDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'value',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    allowSearchFilter: true
  };
  selectedProfileOwnerIds: any = [];

  // regionArray: any = [];
  // selectedRegion: any;
  // selectedRegionList: any = [];
  // selectedBranchList: any = [];
  // branchMultiSelectItems: any = [];
  // selectedBranch: any;
  // selectedEmployeeList: any = [];
  // logeedInUser: any;
  // empID: any;
  // multiDropdownSettings: any;
  // multiSelectRegionDropdown: any;
  // singleSelectionDropdown:any;
  // customersInIndia: any[] = [];
  // customerHeaders: any[] = [];
  // customerMatchedHeaders: any[] = [];
  // formValue2: any;
  // dateTypeFrom: string = 'Arrival From';
  // dateTypeTo: string = 'Arrival To';
  // multiDropdownSettingsWithoutSelect: any;
  // ageFrom: any[] = [];
  // ageTo: any[] = [];
  // heightFrom: any[] = [];
  // heightTo: any[] = [];
  // marital: any[] = [];
  // caste: any[] = [];
  // customersReqObj: any;
  // allCustomersInIndia: any[] = [];
  // loadAllData:boolean;

  constructor(
    public service: WebRequestService,
    private loginDataStore: Data
  ) { 
    this.multiDropdownSettings2 = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,   
    };

    // this.multiDropdownSettingsWithoutSelect = {
    //   singleSelection: true,
    //   idField: 'id',
    //   textField: 'value',
      // selectAllText: 'Select All',
      // unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true,
    //   closeDropDownOnSelection: true,
    //   enableCheckAll: false,
    // };

    // for (var i = 18; i <= 77; i++) {
    //   this.ageFrom.push({ id: i, value: i + 'yrs' });
    //   this.ageTo.push({ id: i, value: i + 'yrs' });
    // }

    // this.loadInitialService();

  }

  // loadInitialService() {
  //   this.service.loadMasterData('Heights').then((response) => {
  //     this.heightFrom = response['result'];
  //     this.heightTo = response['result'];
  //   }).catch((err) => console.log(err));

  //   this.service.loadMasterData('MaritalStatusSearch').then((response) => {
  //     this.marital = response['result'];
  //   }).catch((err) => console.log(err));

  //   this.service.loadMasterData('Caste').then((response) => {
  //     this.caste = response['result'];
  //   }).catch((err) => console.log(err));
  // }

  onSelectEmployee(event) {
    if (this.selectedProfileOwnerIds.indexOf(event.id) > -1) {
      let index = this.selectedProfileOwnerIds.indexOf(event.id);
      this.selectedProfileOwnerIds.splice(index, 1);
    } else {
      this.selectedProfileOwnerIds.push(event.id);
  }
}
  onDeSelectEmployee(event) {
    let index = this.selectedProfileOwnerIds.indexOf(event.id);
    if (index >= 0) {
      this.selectedProfileOwnerIds.splice(index, 1);
    }
  }
  onEmployeeSelectAll(event) {
      this.selectedProfileOwnerIds = [];
      for (let i = 0; i < event.length; i++) {
        this.selectedProfileOwnerIds.push(event[i]['id']);
      }
  }

  onEmployeeDeSelectAll(event) {
      this.selectedProfileOwnerIds = [];
      this.lstForm.get('profileOwner').setValue('');
    }

  ngOnInit(): void {
    this.lstForm = new FormGroup({
      fromRegistrationDate: new FormControl(''),
      toRegistrationDate: new FormControl(''),
      profileOwner: new FormControl('')
    });

    this.customerIndiaForm = new FormGroup({
      arrivalDate: new FormControl(''),
      departureDate: new FormControl(''),
      profileOwner: new FormControl(''),
      regionID: new FormControl(''),
      branchID: new FormControl(''),
      dateType: new FormControl(1),
      ageFrom: new FormControl(''),
      ageTo: new FormControl(''),
      heightFrom: new FormControl(''),
      heightTo: new FormControl(''),
      caste: new FormControl(''),
      marital: new FormControl(''),
      gender: new FormControl(0),
      membership: new FormControl(0)
    });

    // this.multiDropdownSettings = {
    //   singleSelection: false,
    //   idField: 'id',
    //   textField: 'value',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true,
    // };
    // this.multiSelectRegionDropdown ={
    //   singleSelection: false,
    //   idField: 'id',
    //   textField: 'name',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true,
    // }
    // this.singleSelectionDropdown = {
    //   singleSelection: true,
    //   idField: 'id',
    //   textField: 'value',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true,
    // }
    this.service.getAdminMasterData().then((response) => {
      this.profileOwnerArray = response['result'][4];
      this.profileTypeArray = response['result'][5];
    });
    this.prevDate.setDate(this.prevDate.getDate() - 1)
    this.lstForm.patchValue({
      fromRegistrationDate: this.prevDate,
      toRegistrationDate: this.maxDate,
    });
    this.loggedInEmp();
    // this.loadBasicData(); 
  }

  getBranchWIseEmp(loginData) {
    this.service.loadMasterDataWithId('ProfileOwner', parseInt(loginData['branch']))
      .then((empResult) => {
        this.empNameMultiSelectItems = empResult['result'];
        const defaultEmp = this.empNameMultiSelectItems.filter(emp => emp.id === this.loginData['employeeID']);
        this.lstForm.patchValue({
          fromRegistrationDate: this.prevDate,
          toRegistrationDate: this.maxDate,
          profileOwner: defaultEmp[0]
        })
      })
  }

  loggedInEmp() {
    this.loginDataStore.getStoreData('empData')
      .then((dataRes: any) => {
        this.loginData = JSON.parse(dataRes);
        this.isAdmin = this.loginData['isAdmin'];
        this.isLstAccess = this.loginData['isLstAccess'];
        this.isAdmin === 1 || this.isLstAccess === 1 ? this.getBranchWIseEmp(this.loginData) : this.submitLst();
      })
  }

  // loadBasicData() {
  //   this.empID = sessionStorage.getItem('empId')
  //   this.service.getMasterData().then((response) => {
  //     if (response['statusCode'] === 200) {
  //       this.regionArray = response['result'][1];
  //       this.selectedRegion = parseInt(this.loginData['region']);
  //       // this.selectedRegion1 = this.regionArray.filter(item => item.id == this.selectedRegion)
  //       this.selectedRegion = [this.getRegion(this.loginData['region'])]
  //       this.selectedRegionList.push(parseInt(this.loginData['region']))
  //       this.service.loadMasterDataWithId('StateLocation', this.loginData['region']).then((branchResult) => {
  //           this.branchMultiSelectItems = branchResult['result'];
  //           this.selectedBranch = [this.getBranch(this.loginData['branch'])];
  //         })
  //         .catch((err) => console.error(err));
  //       this.service.loadMasterDataWithId('ProfileOwnerbyBranch', parseInt(this.loginData['branch'])).then((empResult) => {
  //           this.empList = empResult['result'];
  //           this.logeedInUser = [this.getEmployee(this.loginData['employeeID'])];

  //         })
  //         .catch((err) => console.error(err));
  //     }

  //   })



  // }

  getEmployee(id) {
    return this.empList.find(val => {
      if (id == val.id) {
        return val;
      }
    })
  }

  _convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [month, day, year].join('/');
  }

  submitLst() {
    this.loadedAllData = false;
    this.scrollDown = false;
    this.LoaderComponent = LoaderComponent;
    this.requestData = {
      empID: Array.isArray(this.selectedProfileOwnerIds) && this.selectedProfileOwnerIds.length > 0 ?
        this.selectedProfileOwnerIds.join(',') :
        (this.loginData['employeeID']),
      fromDate: this.lstForm.value['fromRegistrationDate'] ? this._convertDate(this.lstForm.value['fromRegistrationDate']) : null,
      toDate: this.lstForm.value['toRegistrationDate'] ? this._convertDate(this.lstForm.value['toRegistrationDate']) : null,
      flag: this.loginData['isAdmin'],
      pageFrom: 1,
      pageTo: 100
    }
    this.LoaderComponent = LoaderComponent;
    this.displayValues = [];
    this.allDisplayValues = [];
    this.service.getServiceSlideShowAsync(this.requestData).then(response => {
      if (response['statusCode'] === 200) {
        window.scrollTo(0, 0);
        this.LoaderComponent = '';
        this.expanded = false;
        if (response['result'].length > 0) {
          this.allDisplayValues = response['result'];
          this.displayValues = response['result'];
          this.search1 = 'home';
          response['result'].length > 0 ? this.populateHeaders(this.displayValues[0]) : '';
          this.formValue = response['result'][0];
          this.prepareHeaders();
          this.gridType2 = 'com2';
        } else {
          this.responseMessage = "No Data Found";
          // this.successModal.show();
          // setTimeout(() => {
          //   this.successModal.hide();
          // }, 5000);
        }
        // this.isDataLoadedAssigned = true;
      } else {
        this.LoaderComponent = '';
        this.responseMessage = response['message'];
        // this.successModal.show();
        // setTimeout(() => {
        //   this.successModal.hide();
        // }, 5000);
      }
    })
  }

  requestMoreLSTData(reqData) {
    this.LoaderComponent = LoaderComponent;
    this.displayValues = [];
    this.service.getServiceSlideShowAsync(this.requestData).then(response => {
      if (response['statusCode'] === 200) {
        window.scrollTo(0, 0);
        this.LoaderComponent = '';
        if (response['result'].length > 0) {
          let count = response['result'].length;
          for (let i = 0; i < count; i++) {
            this.allDisplayValues.push(response['result'][i])
          }
          this.displayValues = this.allDisplayValues;
          response['result'].length > 0 ? this.populateHeaders(this.displayValues[0]) : '';
          this.formValue = response['result'][0];
          this.prepareHeaders();
          this.gridType2 = 'com2';
          this.loadedAllData = this.displayValues[0]['totalRows'] === this.displayValues.length ? true : false;
        } else {
          this.responseMessage = "No Data Found";
        }
      } else {
        this.LoaderComponent = '';
        this.responseMessage = response['message'];
        // this.successModal.show();
        // setTimeout(() => {
        //   this.successModal.hide();
        // }, 5000);
      }
    })
  }

  loadMore() {
    if(this.requestData['pageTo'] < this.formValue['totalRows']) {
      this.requestData['pageFrom'] = this.requestData['pageTo'] + 1;
      this.requestData['pageTo'] = this.requestData['pageTo'] + 100;
      this.requestMoreLSTData(this.requestData);
      // this.loadedAllData = false;
    } else if (this.requestData['pageTo'] >= this.formValue['totalRows']) {
      this.loadedAllData = true;
    }
    this.scrollDown = true;
  }

  populateHeaders(data: any) {
    this.allheaders = Object.keys(data).length > 0 ? Object.keys(data) : [];
  }

  prepareHeaders() {
    this.totalFields = [
      { name: 'Myside Profile', id: 'fromProfileid' },
      { name: 'Myside Profile Name', id: 'fromName' },
      { name: 'Myside Employee', id: 'fromemp' },
      { name: 'Myside Ticket', id: 'fromticketid' },
      // { name: 'From Status', id: 'fromticketStatusIDb'},
      { name: 'Service Date', id: 'serviceDate' },
      { name: 'Service Done', id: 'empName' },
      { name: 'Otherside Profile', id: 'toprofileid' },
      { name: 'Otherside Name', id: 'toName' },
      { name: 'Otherside Employee', id: 'toemp' },
      { name: 'Otherside Ticket', id: 'toticketid' },
      { name: 'Options', id: 'options' }
      // { name: 'To Status', id: 'toticketStatusIDb'}
    ]
    this.matchedHeaders = [
      { name: 'Myside Profile', id: 'fromProfileid' },
      { name: 'Myside Profile Name', id: 'fromName' },
      { name: 'Myside Employee', id: 'fromemp' },
      { name: 'Myside Ticket', id: 'fromticketid' },
      // { name: 'From Status', id: 'fromticketStatusIDb'},
      { name: 'Service Date', id: 'serviceDate' },
      { name: 'Service Done', id: 'empName' },
      { name: 'Otherside Profile', id: 'toprofileid' },
      { name: 'Otherside Name', id: 'toName' },
      { name: 'Otherside Employee', id: 'toemp' },
      { name: 'Otherside Ticket', id: 'toticketid' },
      { name: 'Options', id: 'options' }
      // { name: 'To Status', id: 'toticketStatusIDb'}
    ]
    this.headers = [
      'rowID', 'fromProfileid', 'fromName', 'fromemp', 'fromticketid', 'serviceDate', 'empName', 'toprofileid', 'toName', 'toemp', 
      'toticketid', 'options'
    ]
  }

  openTicketModalView(event) {
    if (event['ticketType'] === 'fromticketid') {
      this.type = undefined;
      this.ticketCreate(event['fromProfileid'], event['fromTicket'], event['fromTicketHisoryRelationShip'], event['fromMobileNumber'],
      event['expressinterestlogid'], event['fromcust_id'], event, 'fromTicket','createTicket', event['fromEmpownerid'], 'MSI',
       event['fromTicketMatchmeetingStatus'])
    } else if(event['ticketType'] === 'toticketid') {
      this.type = undefined;
      this.toticketCreate(event['toprofileid'], event['toTicket'], event['toTicketHisoryRelationShip'], event['toMobileNumber'],
      event['expressinterestTologid'], event['tocust_id'], event, 'toTicket','createTicket', event['toEmpownerid'], 'MSI',
       event['toTicketMatchmeetingStatus'])
    } else if (event['existedTicketType'] === 'fromticketid') {
      this.type = 'communication';
      this.openTicket(event['fromProfileid'], event['fromTicket'], event['expressinterestlogid'], event['fromcust_id'])
      // this.isTicketCreteClicked = true;
      // this.commonModal.show();
      // this.ticketData = {profileId: event['fromProfileid'], ticketId: event['fromTicket'], relation: event['fromTicketHisoryRelationShip'], 
      // phoneNumber: event['fromMobileNumber'], expressInterestId: event['expressinterestlogid'], custId: event['fromcust_id'],
      // status: event['fromTicketMatchmeetingStatus'] }
    } else if (event['existedTicketType'] === 'toticketid') {
      this.type = 'communication';
      this.openTicket(event['toprofileid'], event['toTicket'], event['expressinterestTologid'], event['tocust_id'])
        // this.isTicketCreteClicked = true;
        // this.commonModal.show();
        // this.ticketData = {profileId: event['toprofileid'], ticketId: event['toTicket'], relation: event['toTicketHisoryRelationShip'], 
        // phoneNumber: event['toMobileNumber'], expressInterestId: event['expressinterestlogid'], custId: event['tocust_id'],
        // status: event['toTicketMatchmeetingStatus'] }
    }
  }

  openTicket(profileId, ticketId, logID, custID) {
    setTimeout(() => {
      let data;
      this.LoaderComponent = LoaderComponent;
      this.service.getMatchTicketHistory(ticketId, 'I').then((response) => {
        if (response['statusCode'] === 200) {
          this.LoaderComponent = "";
          data = response['result'][0];
          this.ticketData = {
            profileId: profileId, ticketId: ticketId, relation: 39,
            phoneNumber: data['MobileNumber'], expressInterestId: logID,
            custId: custID, email: data['Email'], history: data, 
          }
          this.isTicketCreteClicked = true;
          this.commonModal.show();
        } else {
          this.LoaderComponent = "";

        }
      })

    }, 100)
  }

  ticketCreate(profileId, ticketId, relationtype, mobileNumber, expressId, custId, profile, type, status, empOwner, selectedTab, matchmeetingStatus) {
    this.isTicketCreteClicked = false;
    this.tabValue = selectedTab
    if (type === 'fromTicket') {
      let ticketObject = {
        FromCustID: profile['fromcust_id'],
        ToCustID: profile['tocust_id']
      }
      this.service.ticketCreationMatchFollowup(ticketObject).then((response) => {
        if (response['statusCode'] === 200) {
          profile['fromTicket'] = response['result'];
          let comObject = {
            CallDiscussion: "This Ticket Created By " + this.loginData['firstName'],
            CallType: 379,
            DisplayStatus: 0,
            EmpID: this.loginData['employeeID'],
            TicketID: response['result']
          }
          this.service.callCommunicationLog(comObject).then((resp) => {
            if (resp['statusCode'] === 200) {
              this.isTicketCreteClicked = true;
              this.commonModal.show();
              this.ticketData = { profileId: profileId, ticketId: profile['fromTicket'], relation: relationtype, phoneNumber: mobileNumber, expressInterestId: expressId, custId: custId,status:matchmeetingStatus }
            }
          })
        }

      })
    }
  }

  toticketCreate(profileId, ticketId, relationtype, mobileNumber, expressId, custId, profile, type, status, empOwner, selectedTab, matchmeetingStatus) {
    this.isTicketCreteClicked = false;
    this.tabValue = selectedTab
    if (type === 'toTicket') {
      let ticketObject = {
        FromCustID: profile['tocust_id'],
        ToCustID: profile['fromcust_id']
      }
      this.service.ticketCreationMatchFollowup(ticketObject).then((response) => {
        if (response['statusCode'] === 200) {
          profile['toTicket'] = response['result'];
          let comObject = {
            CallDiscussion: "This Ticket Created By " + this.loginData['firstName'],
            CallType: 379,
            DisplayStatus: 0,
            EmpID: this.loginData['employeeID'],
            TicketID: response['result']
          }
          this.service.callCommunicationLog(comObject).then((resp) => {
            if (resp['statusCode'] === 200) {
              this.isTicketCreteClicked = true;
              this.commonModal.show();
              this.ticketData = { profileId: profileId, ticketId: profile['toTicket'], relation: relationtype, phoneNumber: mobileNumber, expressInterestId: expressId, custId: custId,status:matchmeetingStatus }
            }
          })
        }

      })
    }
  }

  resendComEmail(element) {
    const emailObject = element['element']
    console.log(emailObject, 'dsds');
    let object = {
      "fromCustID": emailObject['fromcust_id'],
      "toCustID": emailObject['tocust_id'],
      "expressInterestID": emailObject['expressInterestID'],
      "logID": emailObject['expressinterestlogid'],
      "isRvrFlag": element['rvrFlag'],
      "empID": this.loginData['employeeID'],
      "fromProfileID": emailObject['fromProfileid'],
      "toProfileID": emailObject['toprofileid']
    }
    this.LoaderComponent = LoaderComponent;
    this.service.resendCommunicationEmail(object).then((response) => {
      if (response['statusCode'] === 200) {
        this.LoaderComponent = "";
        this.responseMessage = response['message']
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000)
      } else {
        this.LoaderComponent = "";
        this.responseMessage = "Resend Failed"
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000)
      }
    })
  }

  closeTicketModal(value) {
    this.isTicketCreteClicked = false;
    this.commonModal.hide();
  }

  closeTicketMatchModal() {
    this.isTicketCreteClicked = false;
    this.commonModal.hide();
  }

  resetSearch(search) {
    this.displayValues = [];
    this.allDisplayValues = [];
    // this.assignProfileForm.reset();
    // this.start = 1;
    // this.end = 15;
    this.lastValue = {};
    // this.assignProfileForm.controls['profileType'].setValue("null");
  }

  modifiedServiceType(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i]['ServiceType'] != null) {
        let array = [];
        let y = this.profileTypeArray.find(x => parseInt(x.id) === parseInt(data[i]['ServiceType']));
        array.push(y);
        data[i]['SelectedServiceType'] = array;
        data[i]['ServiceType'] = parseInt(data[i]['ServiceType'])
      }
      if (data[i]['ProfileSecondaryOwnerID'] != null) {
        let array = [];
        let y = this.profileOwnerArray.find(x => parseInt(x.id) === parseInt(data[i]['ProfileSecondaryOwnerID']));
        array.push(y);
        data[i]['ProfileSecondaryOwnerID'] = array;

      }

      if (data[i]['ProfileOwnerID'] != null) {
        let array = [];
        let y = this.profileOwnerArray.find(x => parseInt(x.id) === parseInt(data[i]['ProfileOwnerID']));
        array.push(y);
        data[i]['ProfileOwnerID'] = array;

      }

    }
    return data;

  }

  filter1(event) {
    let selectedValue = event.target.value;
    this.search2 = '';
    switch (selectedValue) {
      case "home":
        this.search1 = 'home'
        this.displayValues = [];
        setTimeout(() => {
          this.displayValues = this.allDisplayValues
        }, 100)

        break;
      case "bothInterested":
          this.search1 = 'bothInterested'
          this.displayValues = [];
          setTimeout(() => {
            for (let i = 0; i < this.allDisplayValues.length; i++) {
              if (this.allDisplayValues[i]['isBothSideIntrested'] === 1) {
                this.displayValues.push(this.allDisplayValues[i])
              }
            }
          }, 100)
  
          break;  
      case 'view':
        this.search1 = 'view'

        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['fromticketStatusIDb'] === 'V') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)


        break;

      case 'noView':
        this.search1 = 'noView'

        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['fromticketStatusIDb'] === 'NV') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'interested':
        this.search1 = 'interested'

        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['fromticketStatusIDb'] === 'I') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'notInterested':
        this.search1 = 'notInterested'

        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['fromticketStatusIDb'] === 'NI') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'followUp':
          this.search1 = 'followUp'
          this.displayValues = [];
          setTimeout(() => {
            for (let i = 0; i < this.allDisplayValues.length; i++) {
              if (this.allDisplayValues[i]['fromFollowUp'] === 1) {
                this.displayValues.push(this.allDisplayValues[i])
              }
            }
          }, 100)
  
        break;
      case 'notFollowUp':
            this.search1 = 'notFollowUp'
            this.displayValues = [];
            setTimeout(() => {
              for (let i = 0; i < this.allDisplayValues.length; i++) {
                if (this.allDisplayValues[i]['fromFollowUp'] === 0) {
                  this.displayValues.push(this.allDisplayValues[i])
                }
              }
            }, 100)
    
        break; 
    }
  }

  filter3(event) {
    this.search1 = '';
    let selectedValue = event.target.value;
    switch (selectedValue) {
      case 'view':
        // this.search1 = 'view'
        this.search2 = 'view';
        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['toticketStatusIDb'] === 'V') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)


        break;

      case 'noView':
        // this.search1 = 'noView'
        this.search2 = 'noView';
        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['toticketStatusIDb'] === 'NV') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'interested':
        // this.search1 = 'interested'
        this.search2 = 'interested';
        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['toticketStatusIDb'] === 'I') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'notInterested':
        // this.search1 = 'notInterested'
        this.search2 = 'notInterested';
        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['toticketStatusIDb'] === 'NI') {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'followUp':
        // this.search1 = 'followUp';
        this.search2 = 'followUp';
        this.displayValues = [];
        setTimeout(() => {
          for (let i = 0; i < this.allDisplayValues.length; i++) {
            if (this.allDisplayValues[i]['toFollowUp'] === 1) {
              this.displayValues.push(this.allDisplayValues[i])
            }
          }
        }, 100)

        break;
      case 'notFollowUp':
          // this.search1 = 'notFollowUp'
          this.search2 = 'notFollowUp';
          this.displayValues = [];
          setTimeout(() => {
            for (let i = 0; i < this.allDisplayValues.length; i++) {
              if (this.allDisplayValues[i]['toFollowUp'] === 0) {
                this.displayValues.push(this.allDisplayValues[i])
              }
            }
          }, 100)
  
        break;  
    }
  }


  // getBranch(id) {
  //   return this.branchMultiSelectItems.find(val => {
  //     if (id == val.id) {
  //       return val;
  //     }
  //   })
  // }
  // getRegion(id) {
  //   return this.regionArray.find(val => {
  //     if (id == val.id) {
  //       return val.id;
  //     }
  //   })
  // }

  // getSelectedRegion(event) {
  //   if(this.selectedRegionList.indexOf(event.id) == -1) {
  //     this.LoaderComponent = LoaderComponent;
  //     this.branchMultiSelectItems = [];
  //     this.selectedRegionList.push(event.id);
  //     this.service
  //       .loadMasterDataWithId('StateLocation', this.selectedRegionList)
  //       .then((branchResult) => {
  //         if (branchResult['statusCode'] === 200) {
  //           this.LoaderComponent = "";
  //           this.selectedBranch = "";
  //           this.branchMultiSelectItems = branchResult['result'];
  //           this.logeedInUser = "";
  //           this.empList = [];
  //         }
  //       })
  //       .catch((err) => {console.error(err)});
  //   }
  // }

  // onRegionDeSelect(event) {
  //   let index = this.selectedRegionList.indexOf(event.id);
  //   console.log('region',index)
  //   console.log(this.selectedRegionList)
  //     if (index > -1) {
  //       this.selectedRegionList.splice(index, 1);
  //       console.log(this.selectedRegionList)
  //       this.branchMultiSelectItems = [];
  //       this.service
  //         .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
  //         .then((empResult) => {
  //           this.branchMultiSelectItems = empResult['result'];
  //         })
  
  //     }
    
  // }

  // onRegionDeSelectAll(event) {
  //   this.selectedRegionList = event;
  //   this.branchMultiSelectItems = [];
  // }

  // onRegionSelectAll(event) {
  //   console.log(event)
  //   this.selectedRegionList = [];
  //   for (let i = 0; i < event.length; i++) {
  //     this.selectedRegionList.push(event[i]['id'])
  //   }
  //   this.branchMultiSelectItems = [];
  //   console.log('branch',this.selectedRegionList)
  //   this.service
  //     .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
  //     .then((empResult) => {
  //       this.branchMultiSelectItems = empResult['result'];
  //     })
  // }

  // onBranchItemSelect(event) {
  //   if (this.selectedBranchList.indexOf(event.id) > -1) {
  //     let index = this.selectedBranchList.indexOf(event.id);
  //     this.selectedBranchList.splice(index, 1);
  //   } else {
  //     this.empList = [];
  //     this.selectedBranchList.push(event.id);
  //     this.service
  //       .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
  //       .then((empResult) => {
  //         this.empList = empResult['result'];

  //       })
  //   }
  // }

  // onBranchItemDeSelect(event) {
  //   let index = this.selectedBranchList.indexOf(event.id);
  //   if (index >= 0) {
  //     this.selectedBranchList.splice(index, 1);
  //     this.empList = [];
  //     this.service
  //       .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
  //       .then((empResult) => {
  //         this.empList = empResult['result'];
  //       })

  //   }

  // }

  // onBranchDeSelectAll(event) {
  //   this.selectedBranchList = event;
  //   this.empList = [];
  // }
  // onBrachItemsSelectAll(event) {
  //   this.selectedBranchList = [];
  //   for (let i = 0; i < event.length; i++) {
  //     this.selectedBranchList.push(event[i]['id'])
  //   }
  //   this.empList = [];
  //   this.service
  //     .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
  //     .then((empResult) => {
  //       this.empList = empResult['result'];
  //     })
  // }

  // onNameItemSelect(event) {
  //   this.selectedEmployeeList.push(event['id'])
  // }

  // onNameItemDeSelect(event) {
  //   let index = this.selectedEmployeeList.indexOf(event.id);
  //   if (index >= 0) {
  //     this.selectedEmployeeList.splice(index, 1);
  //   }
  // } 

  // prepareRequestObject() {
  //   this.customersReqObj = {
  //     isDashboard: false,
  //     empID:  this.customerIndiaForm.value.profileOwner &&
  //     this.customerIndiaForm.value.profileOwner.length !== 0
  //     ? this.customerIndiaForm.value.profileOwner.length > 1
  //       ? String(
  //         this.customerIndiaForm.value.profileOwner.map((val) => {
  //           return String(val.id);
  //         })
  //       )
  //       : String(this.customerIndiaForm.value.profileOwner[0].id)
  //     : null,
  //     regionId: this.customerIndiaForm.value.regionID &&
  //     this.customerIndiaForm.value.regionID.length !== 0
  //     ? this.customerIndiaForm.value.regionID.length > 1
  //       ? String(
  //         this.customerIndiaForm.value.regionID.map((val) => {
  //           return String(val.id);
  //         })
  //       )
  //       : String(this.customerIndiaForm.value.regionID[0].id)
  //     : null,
  //     branchId: this.customerIndiaForm.value.branchID &&
  //     this.customerIndiaForm.value.branchID.length !== 0
  //     ? this.customerIndiaForm.value.branchID.length > 1
  //       ? String(
  //         this.customerIndiaForm.value.branchID.map((val) => {
  //           return String(val.id);
  //         })
  //       )
  //       : String(this.customerIndiaForm.value.branchID[0].id)
  //     : null,
  //     ageFromID: this.customerIndiaForm.value.ageFrom &&
  //     this.customerIndiaForm.value.ageFrom.length !== 0
  //     ? this.customerIndiaForm.value.ageFrom.length > 1
  //       ? this.customerIndiaForm.value.ageFrom.map((val) => {
  //         return val.id;
  //         })
  //       : this.customerIndiaForm.value.ageFrom[0].id
  //     : null,
  //     ageToID: this.customerIndiaForm.value.ageTo &&
  //     this.customerIndiaForm.value.ageTo.length !== 0
  //     ? this.customerIndiaForm.value.ageTo.length > 1
  //       ? this.customerIndiaForm.value.ageTo.map((val) => {
  //           return val.id;
  //         })
  //       : this.customerIndiaForm.value.ageTo[0].id
  //     : null,
  //     heightFromID: this.customerIndiaForm.value.heightFrom &&
  //     this.customerIndiaForm.value.heightFrom.length !== 0
  //     ? this.customerIndiaForm.value.heightFrom.length > 1
  //       ? this.customerIndiaForm.value.heightFrom.map((val) => {
  //         return val.id;
  //       })
  //       : this.customerIndiaForm.value.heightFrom[0].id
  //     : null,
  //     heightToID: this.customerIndiaForm.value.heightTo &&
  //     this.customerIndiaForm.value.heightTo.length !== 0
  //     ? this.customerIndiaForm.value.heightTo.length > 1
  //       ? this.customerIndiaForm.value.heightTo.map((val) => {
  //         return String(val.id);
  //       })
  //       : this.customerIndiaForm.value.heightTo[0].id
  //     : null,
  //     casteID: this.customerIndiaForm.value.caste &&
  //     this.customerIndiaForm.value.caste.length !== 0
  //     ? this.customerIndiaForm.value.caste.length > 1
  //       ? String(
  //         this.customerIndiaForm.value.caste.map((val) => {
  //           return String(val.id);
  //         })
  //       )
  //       : String(this.customerIndiaForm.value.caste[0].id)
  //     : null,
  //     maritalstatusID: this.customerIndiaForm.value.marital &&
  //     this.customerIndiaForm.value.marital.length !== 0
  //     ? this.customerIndiaForm.value.marital.length > 1
  //       ? String(
  //         this.customerIndiaForm.value.marital.map((val) => {
  //           return String(val.id);
  //         })
  //       )
  //       : String(this.customerIndiaForm.value.marital[0].id)
  //     : null,
  //     genderID: this.customerIndiaForm.value['gender'] ? Number(this.customerIndiaForm.value['gender']) : null,
  //     paidStatus: this.customerIndiaForm.value['membership'] ? Number(this.customerIndiaForm.value['membership']) : null,
  //     isArrival: this.customerIndiaForm.value['dateType'] ? Number(this.customerIndiaForm.value['dateType']) : null,
  //     arrivalaDate: this.customerIndiaForm.value['arrivalDate'] ? this.customerIndiaForm.value['arrivalDate'] : null,
  //     departureDate: this.customerIndiaForm.value['departureDate'] ? this.customerIndiaForm.value['departureDate'] : null,
  //     startindex: 1,
  //     endIndex: 50
  //   }
  // }

  // getCustomersIndia() {
  //   this.prepareRequestObject();
  //   this.loadAllData = false;
  //   this.scrollDown = false;
  //   this.customersInIndia = [];
  //   this.LoaderComponent = LoaderComponent;
  //   this.service.getAvailableCustomersIndia(this.customersReqObj).then((res) => {
  //     if(res['statusCode'] === 200) {
  //       this.LoaderComponent = '';
  //       this.arrivalExpand = false;
  //       this.customersInIndia = res['result'];
  //       this.allCustomersInIndia = res['result'];
  //       this.formValue2 = this.customersInIndia[0];
  //       this.prepareCustomersHeaders();
  //     } else {
  //       this.LoaderComponent = '';
  //       this.responseMessage = res['message'];
        
  //     }
  //   })
  // }

  // loadmore() {
  //   if(this.customersReqObj['endIndex'] < this.formValue2['totalRows']) {
  //     this.customersReqObj['startindex'] = this.customersReqObj['endIndex'] + 1;
  //     this.customersReqObj['endIndex'] = this.customersReqObj['endIndex'] + 50;
  //     this.LoaderComponent = LoaderComponent;
  //     this.customersInIndia = [];
  //     this.service.getAvailableCustomersIndia(this.customersReqObj).then((res) => {
  //       if(res['statusCode'] === 200) {
  //         this.LoaderComponent = '';
  //         let count = res['result'].length;
  //         for (let i = 0; i < count; i++) {
  //           this.allCustomersInIndia.push(res['result'][i])
  //         }
  //         this.customersInIndia = this.allCustomersInIndia;
  //         this.loadAllData = this.customersInIndia[0]['totalRows'] === this.customersInIndia.length ? true : false;
  //         this.formValue2 = this.customersInIndia[0];
  //         this.prepareCustomersHeaders();
  //       } else {
  //         this.LoaderComponent = '';
  //         this.responseMessage = res['message'];
  //       }
  //     })
  //     // this.loadedAllData = false;
  //   } else if (this.customersReqObj['endIndex'] >= this.formValue2['totalRows']) {
  //     this.loadAllData = true;
  //   }
  //   this.scrollDown = true;
  // }

  // prepareCustomersHeaders() {
  //   this.customerMatchedHeaders = [
  //     { title: 'Sno', value: 'serial' },
  //     { title: 'Profile ID', value: 'profileID'},
  //     { title: 'Profile Owner', value: 'profileOwnerName'},
  //     { title: 'First Name', value: 'firstName' },
  //     { title: 'Last Name', value: 'lastName' },
  //     { title: 'Caste', value: 'caste' },
  //     { title: 'City', value: 'city' },
  //     { title: 'Arrived On', value: 'arrivedOn' },
  //     { title: 'Departure On', value: 'departingOn' },
  //   ]

  //   this.customerHeaders = ['serial', 'profileID', 'profileOwnerName', 'firstName', 'lastName', 'caste', 'city', 'arrivedOn', 'departingOn']
  // }

  // dateTypeChange(event) {
  //  if(event.value === 1) {
  //    this.dateTypeFrom = 'Arrival From';
  //    this.dateTypeTo = 'Arrival To';
  //  } else if(event.value === 2) {
  //   this.dateTypeFrom = 'Departure From';
  //   this.dateTypeTo = 'Departure To';
  //  } else if(event.value === 0) {
  //   this.dateTypeFrom = 'Arrival Date';
  //   this.dateTypeTo = 'Departure Date';
  //  }
  // }

  // clearDate(field) {
  //   if (field  === 'arrivalDate') {
  //     this.customerIndiaForm.controls['arrivalDate'].reset();
  //   } else if (field === 'departureDate') {
  //     this.customerIndiaForm.controls['departureDate'].reset();
  //   }
  // }

}
